import { connect } from 'react-redux'
import Permalink from './Permalink'
import { togglePermalink } from '../../actionCreators'

const mapStateToProps = (state, ownProps) => ({
	visible: state.showPermalink,
	stompunktId: state.currentStompunkt
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	onClose: () => dispatch(togglePermalink())
})

export default connect(mapStateToProps, mapDispatchToProps)(Permalink)



// WEBPACK FOOTER //
// ./src/components/Stompunkt/PermalinkContainer.js